
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';


const classNames = mergeStyleSets({
    toolbar: {
    }
});


const ToolbarCommandButton = ({horizontalAlign, items, styles}) => {
    horizontalAlign = horizontalAlign || 'end';

    const getStyles = () => {
        return {
            label: {
                color: getTheme().semanticColors.link
            },
            labelHovered: {
                color: getTheme().semanticColors.linkHovered
            },
            labelDisabled: {
                color: getTheme().semanticColors.buttonTextDisabled
            },
            ...(styles || {})
        };
    }

    const getIconProps = (menuItem) => {
        return menuItem.icon
            ? {iconName: menuItem.icon}
            : null;
    }

    const getMenuProps = (toolbarItem) => {
        return toolbarItem.items
            ? {
                items: toolbarItem.items.map((item, index) => {
                    return {
                        disabled: item.disabled,
                        key: index,
                        text: item.text,
                        title: item.title,
                        onClick: item.onClick,
                        iconProps: getIconProps(item)
                    };
                })
            }
            : null;
    }

    return (
        <Stack
            horizontal
            horizontalAlign={horizontalAlign}
            className={classNames.toolbar}
        >
            {items.map((item, index) => {
                return (
                    <CommandButton
                        key={index}
                        onClick={item.onClick}
                        text={item.text}
                        title={item.title}
                        iconProps={getIconProps(item)}
                        styles={getStyles()}
                        disabled={item.disabled || (!item.onClick && !item.items)}
                        menuProps={getMenuProps(item)}
                    />
                );
            })}
        </Stack>
    )
}

export default ToolbarCommandButton;
